import { useCallback } from 'react';

// components
import { Dropdown } from 'components/Dropdown/Dropdown';

// utils
import { locatorEvent } from '../trackingActions';
import { useTracking } from 'utils/hooks/useTracking';
import { emptyStringFallback, isEmpty } from 'utils/is-empty';

interface CategoryFilterProps {
  setFilterCategory: (filterCategory?: string) => void;
  filterCategories: string[];
  label: string;
  sortedF1Categories: string[];
  filterCategory?: string | null;
}

export function CategoryFilter({
  filterCategories,
  filterCategory,
  setFilterCategory,
  label,
  sortedF1Categories,
}: Readonly<CategoryFilterProps>) {
  const track = useTracking();
  const handleDropdownClick = useCallback(
    (item) => {
      setFilterCategory(emptyStringFallback(item?.id, undefined));
      track.trackEvent(locatorEvent('Locator-Search', emptyStringFallback(item?.id, label)));
    },
    [track],
  );

  if (isEmpty(filterCategories)) return null;

  let categories;
  if (!isEmpty(sortedF1Categories)) {
    categories = sortedF1Categories.filter((item) => filterCategories.includes(item));
  } else {
    categories = filterCategories;
  }

  const items = categories
    .filter((x) => x)
    .map((value) => {
      return { id: value, name: value };
    });

  return (
    <>
      <Dropdown
        placeholder={emptyStringFallback(filterCategory, label)}
        label={label}
        items={items}
        handleDropdownClick={handleDropdownClick}
      />
    </>
  );
}
